import styled, { css } from 'styled-components';
import colors from '@theme/colors';

export const TextInputWrapper = styled.div`
  position: relative;
  ${({ inline }) =>
    inline &&
    css`
      display: flex;
      align-items: center;
    `}
  label {
    color: ${colors.PRIMARY};
    font-size: 12px;
    ${({ inline, gap }) =>
      inline &&
      gap &&
      css`
        display: flex;
        align-items: center;
        margin-right: ${gap};
      `}
  }
  input {
    all: unset;
    background-color: #f9f9f9;
    border: 1px solid ${colors.GREY};
    border-radius: 3px;
    outline: none;
    color: ${colors.TEXT};
    padding: 6px 10px;
  }
  label > img {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 14px;
  }
  ${({ underlined }) =>
    underlined &&
    css`
      > label {
        display: block;
        color: ${colors.FORM_GREY};
        padding-top: 3px;
      }
      > input {
        border-color: transparent transparent ${colors.BORDER_GREY};
        border-radius: 0;
        background: transparent;
        padding: 4px 0 0;
        margin-top: 3px;
        width: 100%;
      }
    `}
`;



// WEBPACK FOOTER //
// ./components/molecules/TextInput/layout.js